import { COMPONENT_ADD, COMPONENT_DEL, COMPONENT_CALLBACK, COMPONENT_POP, COMPONENT_PUSH, COMPONENT_CALLBACK_DEL } from '@/store/mutation-types'

const eventBusKey = 'events'
const uicreate = 'uicreate'
const update = 'update'

export default {

  data: function () {
    return {
      stateEvents: {
        supported: {},
        acknowledged: 0
      },
      stateObjectKey: null
    }
  },

  computed: {
    events: function () {
      return this._get(eventBusKey)
    },
    keyName: function () {
      switch (this.$route.name) {
        case 'viewProject':
          return `project.${this.$route.params.id}`
        case 'viewStory':
          return `story.${this.$route.params.id}`
        case 'home':
          return 'home.state'
        case 'messaging':
          return 'message.state'
        case 'search':
          return 'search.state'
        case 'profile':
          return 'profile'
        case 'UpdateFeed':
          return 'feed'
        case 'resources':
          return 'resource.state'
        case 'regional':
          return 'regional.state'
        case 'auditoriumType':
          return 'auditoriumType'
      }
    }
  },

  watch: {
    events: function () {
      const length = this.events.length
      if (length > 0 && length !== this.stateEvents.acknowledged) {
        this.events.slice(this.stateEvents.acknowledged).forEach((event) => {
          this.stateEvents.acknowledged++
          if (typeof this.stateEvents.supported[event] === 'function') {
            this.stateEvents.supported[event]()
          }
        })
      }
    }
  },

  created: function () {
    this._setObjectKey(this.keyName)
  },

  methods: {
    _setObjectKey: function (key) {
      this.stateObjectKey = key
    },

    _key: function (key) {
      return this.stateKeyPrefix ? `${this.stateKeyPrefix}.${key}` : key
    },

    _set: function (key, value) {
      this.$store.commit(COMPONENT_ADD, { key, value, stateObjectKey: this.stateObjectKey })
      return value
    },

    _get: function (key, defaultValue = null) {
      const value = this.$store.getters.componentGetValue(key, this.stateObjectKey)
      return value !== undefined && value !== null ? value : defaultValue
    },

    _getObject: function () {
      let value = null
      if (this.stateObjectKey) {
        value = this.$store.getters.componentGetValue(this.stateObjectKey)
      }

      return value || {}
    },

    _delete: function (key) {
      return this.$store.commit(COMPONENT_DEL, { key, stateObjectKey: this.stateObjectKey })
    },

    _clear: function () {
      if (this.stateObjectKey) {
        this.$store.commit(COMPONENT_DEL, { key: this.stateObjectKey })
        this.$store.commit(COMPONENT_CALLBACK_DEL, { key: this.stateObjectKey })
      }
    },

    _pop: function (key) {
      let value = this._get(key)
      if (value) {
        if (Array.isArray(value)) {
          value = value[value.length - 1]
          this.$store.commit(COMPONENT_POP, { key, stateObjectKey: this.stateObjectKey })
        } else {
          this._delete(key)
        }
      }
      return value
    },

    _push: function (key, value) {
      return this.$store.commit(COMPONENT_PUSH, { key, stateObjectKey: this.stateObjectKey, value })
    },

    _toggle: function (key) {
      const value = this._get(key, true)
      this._set(key, !value)
      return !value
    },

    _register: function (key, callback) {
      return this.$store.commit(COMPONENT_CALLBACK, { key, stateObjectKey: this.stateObjectKey, callback })
    },

    _callback: function (key, params) {
      const callback = this.$store.getters.componentGetCallback(key, this.stateObjectKey)
      if (callback) {
        return callback(params)
      }
    },

    _globalCallback: function (key, params) {
      const stateObjectKey = this.stateObjectKey
      this.stateObjectKey = null
      const result = this._callback(key, params)
      this.stateObjectKey = stateObjectKey
      return result
    },

    _on: function (name, callback) {
      this.stateEvents.supported[name] = callback
    },

    _emit: function (name) {
      this._push(eventBusKey, name)
    },

    _uicreateKey: function (projectId, comment, post, isUpdate) {
      return uicreate + '.' + projectId +
        (comment ? ('.c' + comment.id) : '') +
        (post && post.id ? ('.p' + post.id) : '') +
        (isUpdate ? '.' + update : '')
    }
  }
}
